import React, { Component} from 'react';
import {injectIntl, intlShape, FormattedMessage} from 'react-intl';
import {i18nIntl} from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import FieldLabel from '../builder/FieldLabel';

import UserAvatar from './UserAvatar';

class SocialLogin extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			//logged:{avatar:"https://scontent.cdninstagram.com/vp/77b946fa36aa043b3e2f5517215feb52/5BE993C9/t51.2885-19/10369345_660570320693364_1572545984_a.jpg",id:"1420430121",name:"Easypromos",network:"instagram",status:1,username:"easypromosapp"},
			logged:false,
			data:this.props.data,
		}

		this.nets = [];

		if(props.data.social_login_fb) this.nets.push({network:'facebook'});
		//if(props.data.social_login_ig) this.nets.push({network:'instagram'});

		if(props.data.promotion_id) this.state.promotion_id = props.data.promotion_id;

		/*array(
			'status'	=> 1,
			'id'		=> $_SESSION[$session]['user']['id'],
			'username'	=> $_SESSION[$session]['user']['username'],
			'name'		=> $_SESSION[$session]['user']['full_name'],
			'avatar'	=> $_SESSION[$session]['user']['profile_picture'],
		)*/

		//Check if logged on FB

		if (props.data.social_login_fb) this.checkFB();


		if (props.user != undefined) {
			this.state.logged = props.user;
			if(props.onLogin !== undefined) props.onLogin(this.state.logged);
		}

		// EP.getFBUser(r => {
		// 	if(r.error !== undefined) return;
		// 	this.logged({
		// 		status:1,
		// 		id:r.id,
		// 		username: r.name,
		// 		name: r.name,
		// 		first_name: r.first_name,
		// 		last_name: r.last_name,
		// 		email:r.email,
		// 		avatar:'https://graph.facebook.com/'+r.id+'/picture',
		// 	}, 'facebook');
		// });
	}

	checkFB() {
		EP.getFBUser(r => {
			if(r.error !== undefined) {
				//user_status = undefined;
				return;
			}

			this.logged({
				status:1,
				id:r.id,
				username: r.name,
				name: r.name,
				first_name: r.first_name,
				last_name: r.last_name,
				email:r.email,
				avatar:'https://graph.facebook.com/'+r.id+'/picture?access_token='+FB.getAuthResponse()['accessToken'],
			}, 'facebook');
		});
	}

	/**
	 * Try to login into a social network
	 * @param  {[type]} social [description]
	 * @return {[type]}        [description]
	 */
	login(social) {
		if(social === "facebook") {
			fbEnsureUserStatus(() => {
				if(user_status == 'connected') {
					this.checkFB();
				} else {
					// The user is not logged prompt it
					// Instead a popup should apperar when we have more networks

					var permissions = (this.state.data.permissions != undefined) ? this.state.data.permissions : 'email';
					FB.login((response) => {
						if(response.authResponse) {
							this.checkFB();
						}
					}, { scope: permissions });
				}
			});

			return;
		}

		var ua = navigator.userAgent.toLowerCase();
		var is_mobile = ua.indexOf("android") > -1 || ua.indexOf("blackberry") > -1 || ua.indexOf("ipad") > -1 || ua.indexOf("iphone") > -1 || ua.indexOf("windows phone") > -1 || ua.indexOf("ipod") > -1 || ua.indexOf("webos") > -1 ? true : false;
		var target_blank = true;
		if(is_mobile) {
		  target_blank = false;
		}

		if(target_blank) {
			//Get data from the endpoint
			this.popup = window.open('', '_blank', "width=500,height=400,scrollbars=no");

			this.popup.onbeforeunload = function() {
			}
		}
	}

	/**
	 * Actions to take when user is logged
	 * @param  {[type]} resp   [description]
	 * @param  {[type]} social [description]
	 * @return {[type]}        [description]
	 */
	logged(resp, social) {
		var r = {...resp, network:social};
		this.setState({ logged:r });
		if(this.props.onLogin !== undefined) this.props.onLogin(r);
	}

	/**
	 * Logout the user
	 * @return {[type]} [description]
	 */
	logout = () => {
		if(this.state.logged.network == 'facebook') {
			fbEnsureUserStatus(() => {
				if(user_status == 'connected') {
					FB.logout((response) => {
					});
				}
			});

			if (this.state.promotion_id !== undefined) {
				$.get('/utils/fblogout/'+this.state.promotion_id);
			}
		}

		//Issue a logout
		$.get('/utils/social/'+this.state.logged.network+"/logout");

		if(this.props.onLogout !== undefined) this.props.onLogout(this.state.logged.network);
		this.setState({logged:false});
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const data = this.state.data;

		const signin_mandatory = (this.props.data.social_login_mandatory != undefined) ? this.props.data.social_login_mandatory : false;
		const import_media_from_network = true;

		//If disabled we show nothing
		if(data.social_login === false) {
			const container = document.querySelector('.social_login');
			if(container != undefined) {
				//container.classList.add('without_contents');
				container.remove();
			}
			return null;
		}

		var profile_url = false;
		var button_label = "Log in";
		if(this.state.logged) {
			switch(this.state.logged.network) {
				/*case 'instagram':
					profile_url = 'https://www.instagram.com/' + this.state.logged.username;
					break;*/
				case 'facebook':
				default:
					profile_url = 'https://www.facebook.com/' + this.state.logged.id;
					break;
			}
		}

		return (
			<div>
				{(!this.state.logged) ? (
					<div class={'social_network_signin'+((signin_mandatory) ? ' is_mandatory' : '')}>
						{(signin_mandatory) ? (
							<p class="label hb_secondaryFont">{i18n("Log in to continue")}:</p>
						) : (
							<p>{i18n("Register easily with")}:</p>
						)}
						<div class="networks_list gui_ribbons">
							{this.nets.map((n, i) => (
								<ActionLink key={i} _class={{other:'with_icon ep-'+n.network}} onClick={() => this.login(n.network)}>{button_label}</ActionLink>
							))}
						</div>
					</div>
				) : (
					<div class="is_logged_sn">
						<FormattedMessage id="Logged as {username}" values={{username:<ActionLink _href={profile_url} _target="_blank" _class={{other:'logged_user ep-'+this.state.logged.network}}>{this.state.logged.name}</ActionLink>}} />

						{this.state.logged.network && (
							<ActionLink onClick={this.logout}>Logout</ActionLink>
						)}
						{/*<img src={this.state.logged.avatar} width={50} height={50} /> {this.state.logged.name}
						*/}
					</div>
				)}
			</div>
		)
	}
}

export default injectIntl(SocialLogin);